import toast from 'react-hot-toast';
import {AUTHORIZATION_URL, BASE_URL, PROFILE_URL} from "../config";

const errors = {
  server: 'Something went wrong!',
  request: 'Input correct request, Please!',
}

export default class API {
_baseUrl = BASE_URL;

    async Unauthorized(url='') {
        try {
          if(url==='/logout'){
            return
          }
            await this.httpRequest('/logout')
            localStorage.clear();
            window.location.href = AUTHORIZATION_URL;
            throw new Error(`Недостаточно прав! Зайдите под ролью с достаточными правами!`);
        } catch (e) {
            throw new Error(e);
        }
    }

    async httpRequest(url, method = 'GET', options, messageSuccess, messageError) {
        try {
            let response;

            if (method === 'GET' || method === 'DELETE') {
                response = await fetch(`${this._baseUrl}` + url, {method: method, credentials: 'include',});
            } else if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
                const requestOptions = {
                    method: method,
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(options),

                    credentials: 'include',
                };
                response = await fetch(`${this._baseUrl}` + url, requestOptions);
            } else throw new Error('Неподдерживаемый метод');

            if (!response.ok) {
                if (response.status === 401) { // // проверка jwt при обращении к api
                    await this.Unauthorized(url);
                }
                if (response.status === 409) { // проверка уникальности логина при создании пользователя
                    toast.error('Логин занят!');
                    throw new Error(`Логин занят!`);
                }
                // if (response.status === 418) { //непредвиденая ошибка
                //     toast.error('Упс.. Что-то пошло не так')
                //     throw new Error(`Упс.. Что-то пошло не так`)
                // }
                if (response.status === 523) {// бд недоступна
                    toast.error('База данных недоступна. Попробуйте позже!')
                    throw new Error(`'База данных недоступна. Попробуйте позже!'`)
                }
                throw new Error(`Could not fetch, received ${response.status}`) // ошибки с инными статус кодами
            } else {
                if (messageSuccess) {
                    toast.success(messageSuccess)
                }
                return await response.json();
            }
        } catch (e) {
            console.error(e.message || e);
            if (messageError) {
                toast.error(messageError);
            }
            throw new Error(e.message || e);
        }
    }

    // Авторизация //ПЕРЕСМОТРЕТЬ
    async getAccess(login, password) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({login: login, password: password}),
                credentials: 'include'
            };
            const response = await fetch(`${this._baseUrl}/login`, requestOptions)
            if (!response.ok) {
                if (response.status === 401) { // проверка login and password
                    toast.error('Не удалось выполнить вход!');
                    const err = await response.text();
                    if (err.includes('Login'))
                        throw new Error(`Неверный логин`);
                     else if (err.includes('Password'))
                        throw new Error(`Неверный пароль`);
                    throw new Error(`Ошибка авторизации`);
                }
                throw new Error(`Could not fetch, received ${response.status}`);
            } else
                return await response.json()
        } catch (err) {
            throw new Error(err.message);
        }
    }

    async authorization(login, password, logIn, setError) {
        try {
            const signIn = await this.getAccess(login, password)
            localStorage.setItem('id', signIn['id']);
            localStorage.setItem('idOrganization', signIn['idOrganization']);
            localStorage.setItem('nameOrganization', signIn['nameOrganization']);
            localStorage.setItem('name', signIn['name']);
            logIn(signIn['type'])
            window.location.href=PROFILE_URL
        } catch (err) {
            setError(err.message);
        }
    }

    async logOut() {
        return await this.httpRequest('/logout', 'GET')
    }

    //Organizations
    async getOrganizations() {
        return await this.httpRequest('/organizations', 'GET')
    }

    async addOrganization(options) {
        await this.httpRequest('/organizations', 'POST', options, 'Организация успешно добавлена', 'При добавлении организации произошла ошибка')
    }

    async editOrganization(id, options) {
        await this.httpRequest('/organizations/' + id, 'PUT', options, 'Организация успешно отредактирована', 'При редактировании организации произошла ошибка')
    }

    async deleteOrganization(id) {
        await this.httpRequest('/organizations/' + id, 'DELETE')
    }

    async getUsersByOrganization(id) {
        return await this.httpRequest(`/organizations/` + id + '/users', 'GET')
    }

    async getChildOrganizations(id) {
        return await this.httpRequest('/organizations/' + id + '/organizations', 'GET')
    }

    //users
    async getUsers(id) {
        return await this.httpRequest(`/users/` + id + '/users', 'GET')
    }

    async addUser(id, options) {
        try {
            await this.httpRequest(`/users/` + id + '/users', 'POST', options, 'Добавление выполнено успешно', 'При добавлении возникла ошибка')
        } catch (e) {
            throw new Error(e.message)
        }
    }
    async importUsers(id,filesData) {
        try
        {
            const files = new FormData()
            filesData.forEach((item, i) => files.append(i, item))
            const requestOptions = {
                method: 'POST',
                body: files,
                credentials: 'include',
            };

            const response = await fetch(`${this._baseUrl}/users/${id}/import`, requestOptions)

            if (!response.ok) {
                throw new Error(response.statusText);
            } else {
                const data = await response.json()
                if(data.is_correct) {
                    toast.success('Файлы упешно отправились');
                }
                else{
                    toast.error('Файл содержит ошибки!');
                }
                return data
            }
        }
        catch (err) {
            console.error('myError: ' + err);
            toast.error('При отправке файлов произошла ошибка');
        }
    }
    async editUser(id, options) {
        await this.httpRequest('/users/' + id, 'PUT', options, 'Редактирование прошло успешно', 'При редактировании возникла ошибка')
    }

    async deleteUser(id) {
        await this.httpRequest(`/users/` + id, 'DELETE')
    }

    async getUser(id) {
        return await this.httpRequest(`/users/` + id, 'GET')
    }

    async addSubUserInformation(options, idUser) {
        await this.httpRequest('/users/' + idUser+'/subinfo', 'PUT', options, 'Добавление прошло успешно', 'При добавлении произошла ошибка')
    }

    async getSubUserInformation(idUser) {
        return await this.httpRequest('/getSubUserInformation/' + idUser +'/subinfo', 'GET')
    }

    async sendResult(id, options) {
        console.log(Object.assign({}, options), "OPTIONS")
        await this.httpRequest('/users/' + id + '/result', 'POST', options, 'Результат успешно отправлен')
    }

    async getLastResult(userId) {
        return await this.httpRequest('/users/' + userId + '/result', 'GET')
    }

    async getCheckQuestions(id,is_checked=0) {
        return await this.httpRequest(`/users/` + id + '/questions?is_checked='+is_checked, 'GET')
    }

    async getStatistics(userId, testId) {
        return await this.httpRequest('/users/' + userId + '/tests/' + testId+'/statistics', 'GET')
    }

    async getUserTests(userId) {
      return await this.httpRequest('/users/' + userId+'/tests','GET')
    }


    //Texts
    async addText(options) {
      return await this.httpRequest('/texts', 'POST', options, 'OKK', "NEOK")
    }
    async getTexts() {
      return await this.httpRequest('/texts', 'GET')
    }
    async getText(id) {
        return await this.httpRequest('/texts/'+id, 'GET')
    }
    async editText(id,body) {
        return await this.httpRequest('/texts/'+id, 'PUT',body,'Успешно отредактированно','При редактировании произошла ошибка')
    }

    //tests
    async getTests(isDemo=false,isStatistics=false) {
            return await this.httpRequest(`/tests?isDemo=${isDemo}&isStatistics=${isStatistics}`, 'GET')
    }
    async testsDemo(options) {
        return await this.httpRequest('/tests/demo', 'PATCH',options,'Демо тест изменен','Ошибка при изменении демо теста')
    }
    async addQuestionsToComplexTask(id, options) {
        await this.httpRequest('/tests/' + id + '/questions', 'PATCH', options, 'Добавление вопросов успешно выполнилось', 'Во время добавления вопросов произошла ошибка. Тест не добавился')
    }

    async addTest(options, questions) {
      let sendQuestionsData = {
          ...options,
          tasks: questions,
        }
      
      await this.httpRequest('/tests', 'POST', sendQuestionsData, 'Добавление теста успешно выполнилось!', 'Во время добавления теста произошла ошибка. Тест не добавился')
    }

    async addComplexTask(options, texts, questions) {
      let sendQuestionsData = {
        ...options,
        texts: texts,
        questions: questions,
      }
      await this.httpRequest('/tasks', 'POST', sendQuestionsData, 'Добавление шапки теста успешно выполнилось!', 'Во время добавления шапки теста произошла ошибка. Тест не добавился')
    }

    async deleteComplexTask(id) {
      await this.httpRequest('/tasks/' + id, 'DELETE', {}, 'Комплексное задание успешно удалено', 'При удалении комплексного адания произошла ошибкаб попробуйте позже')
    }

    async getComplexTasks() {
      return await this.httpRequest('/tasks', 'GET')
    }
    async getComplexTask(id) {
        return await this.httpRequest('/tasks/' + id, 'GET')
    }
    async editComplexTask(id,option) {
        return await this.httpRequest('/tasks/' + id, 'PUT',option,'Успешно изменено','При редактировании произошла ошибка')
    }

    async editTest(id, options) {
        await this.httpRequest('/tests/' + id, 'PUT', options, 'тест успешно отредактирована', 'При редактировании теста произошла ошибка')
    }

    async deleteTest(testId) {
        await this.httpRequest('/tests/' + testId, 'DELETE')
    }

    async getTest(id,isFull=false) {
      return await this.httpRequest(`/tests/${id}${isFull?'?full=true':''}`, 'GET')
    }

  //   async getNewTest(id) {
  //     return await this.httpRequest(`/tests/new` + id, 'GET')
  // }

    async startsTests(options) {
        await this.httpRequest('/tests/start', 'PATCH', options, 'Тесты запущены', 'Произошла ошибка при запуске тестов')
    }

    async finishTests() {
        return await this.httpRequest('/tests/finish', 'PATCH')
    }


    //questions
    async getQuestions() {
        return await this.httpRequest(`/questions`, 'GET')
    }

    async addFiltersToQuestion(id, options) {
        await this.httpRequest('/questions/' + id + '/filters', 'PATCH', options, 'Фильтры успешно добавлены', 'При добавлении фильтров произошла ошибка')
    }

    async addQuestion(options) {
        const response = await this.httpRequest('/questions', 'POST', options, 'Добавление шапки вопроса успешно выполнилось!', 'Во время добавления шапки вопроса произошла ошибка')
        // const sendFiltersData = {
        //     questionId: response.id_question,
        //     tags: filters,
        // }
        // await this.addFiltersToQuestion(response.id_question, sendFiltersData)
        // return response.id_question
    }

    async editQuestion(id,options) {
        await this.httpRequest('/questions/'+id, 'PUT',options, 'Редактирование вопроса прошло успешно', 'При редактировании возникли проблемы')
    }

    async deleteQuestion(questionId) {
        await this.httpRequest('/questions/' + questionId,'DELETE')
    }

    async getOneQuestion(idQ) {
        return await this.httpRequest('/questions/' + idQ, 'GET')
    }
    async addQuestionsToComplex(id,options) {
      await this.httpRequest('/questions/'+id+'/questions','PATCH', options, 'Вопросы успешно добавлены', 'При добавлении вопросов произошла ошибка')
    }
    async addComplexQuestion(options) {
      const response = this.httpRequest('/addComplexQuestion','POST', options, 'Задание успешно добавлено', 'При добавлении возникла ошибка')
      const sendQuestionsData = {
        complexId: response.id_question,
        questions: options,
      }
      await this.addQuestionsToComplex(response.id_question,sendQuestionsData)
    }
    async deleteFilterFromQuestion(filterId, questionId) {
      await this.httpRequest('/questions/' + questionId + 'filters/' + filterId,'DELETE')
    }


  //categories
    async getCategories() {
      return await this.httpRequest('/categories','GET')
    }

    async addCategory(options) {
      await this.httpRequest('/categories','POST', options, 'Категория добавлена успешно', 'При добавлении категории произошла ошибка')
    }

    async editCategory(id,options) {
      await this.httpRequest('/categories/'+id,'PUT', options, 'Редактирование успешно выполнено', 'При редактировании произошла ошибка')
    }

    async deleteCategory(categoryId) {
    await this.httpRequest('/categories/' + categoryId,'DELETE')
    }

    async getFilters() {
      return await this.httpRequest(`/categories/filters`,'GET')
    }

    async addFilters(id,options) {
      await this.httpRequest('/categories/'+id+'/filters','PATCH', options, 'Добавление фильтров прошло успешно', 'При добавлении фильтров произошла ошибка')
    }

    async deleteFilter(filterId) {
      await this.httpRequest('/categories/filters/' + filterId,'DELETE')
    }
    async editFilter(filterId,options) {
      await this.httpRequest('/categories/filters/' + filterId,'PUT', options, 'Редактирование прошло успешно', 'При редактировании возникли проблемы')
    }

  //feedback
    async getFeedback() {
      return await this.httpRequest('/feedback','GET')
    }

    async sendMessage(options, message, errorMessage) {
      await this.httpRequest('/feedback','POST',options, message, errorMessage)
    }
    async getAllFeedback() {
      return await this.httpRequest('/getAllFeedback')
    }

    async closeFeedback(idFeedback) {
      await this.httpRequest('/feedback/'+idFeedback,'PATCH')
    }

    async getCurrentFeedback(feedbackId) {
      return await this.httpRequest('/getFeedback/' + feedbackId)
    }



    //subinformation
    async getSubInformationFields() {
      return await this.httpRequest('/subinformation','GET')
    }

    async addSubInformationFields(options) {
      await this.httpRequest('/subinformation','POST', options, 'Поля успешно добавлены', 'При добавлении полей произошла ошибка')
    }

     //files
    async sendFiles(filesData) {
      try
      {
        const files = new FormData()
        filesData.forEach((item, i) => files.append(i, item))
        const requestOptions = {
          method: 'POST',
          body: files,
          credentials: 'include',
        };

        const response = await fetch(`${this._baseUrl}/files`, requestOptions)

        if (!response.ok) {
            throw new Error(response.statusText);
        } else {
          toast.success('Файлы упешно отправились');
          const data = await response.json()
          return data
        }
      }
      catch (err) {
        console.error('myError: ' + err);
        toast.error('При отправке файлов произошла ошибка');
      }
    }

     //result
    async sendCheckedResult(options) {
      await this.httpRequest('/result','POST', options, 'Добавление успешно выполнилось!', 'Во время отправления произошла ошибка. Ответ не отправился')
    }
    async sendCheckSuperExpert() {
       return await this.httpRequest('/results/confirm','GET',null , 'Успешно отправлено на проверку!', 'Во время отправления произошла ошибка.')
    }
    //database
    async clearDataBase(){
      return await this.httpRequest('/database/clear','GET', {},'Запрос выполнился успешно','Запрос выполнился безуспешно')
    }
    
    async deleteText(id) {
      await this.httpRequest('/texts/' + id , 'DELETE', {}, 'Удаление текста выполнено','Что-то пошло не так, перезагрущите страницу')
    }
    //instructions
    async getInstructions(isAllInstructions=false) {
        let allInstructions = isAllInstructions ? '?all=true' : '';
        return await this.httpRequest('/instructions'+allInstructions,'GET')
    }
    async editInstructions(role,options) {
        return await this.httpRequest('/instructions/'+role,'PUT',options,'Успешно изменено','Ошибка при редактировании')
    }
}
